import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { baseUrl } from '../components/constant';
import { toast } from 'react-toastify';

const Packages = () => {
  const [Images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [Package, setPackage] = useState([]);

  const navigate = useNavigate();

  const fetccPackges = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      console.log("baseUrl", baseUrl)
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/subscriptions`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data", data)
        setPackage(data); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch Ads');
      }
    } catch (err) {
      setError('Failed to fetch Ads');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetccPackges();
  }, []);


  const handleDeleteClick = (category) => {
    console.log("category", category)
    setCategoryToDelete(category);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    if (!categoryToDelete) return;

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('subscription_id', categoryToDelete.id);
      formData.append('is_active', categoryToDelete.is_active == '1' ? '0' : '1');
      console.log("formData", formData)
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/subscriptions-status`, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toast.success('change status successfully!');
        setShowModal(false); // Close the modal after successful deletion
        fetccPackges()

      } else {
        toast.error('Failed to disable package');
      }
    } catch (err) {
      toast.error('An error occurred while disable the package.');
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowModal(false);
    setCategoryToDelete(null);
  };

  const handleAddNewPackage = () => {
    navigate('/Packages/New');
    // navigate('/Ads/New');
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="dashboard">
      <button className="add-category-button" onClick={handleAddNewPackage} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>
        <FontAwesomeIcon icon={faPlus} /> Add New Package
      </button>
      <div className="category-list">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}


        {!loading && Package.map(packege => (
          <div key={packege.id} className="category-item">


            <div className="category-row">
              <span className="category-id">ID: {packege.id}</span>
              <div style={{ flexGrow: 1 }}>
                <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>{packege.name} - {packege.name_ar}</h3>
                <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>Price : {packege.price}</h3>
                {packege.duration ?
                  <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>Duration : {packege.duration} days</h3>
                  :
                  <></>
                }
              </div>

              <div className="buttons">

                {/* <button className="delete" onClick={() => handleDeleteClick(packege)}>
                  {packege.is_active == '1' ? 
                  <p>Deactive</p>
                :
                <p>active</p>
                 
                  }
                </button> */}


                <button className="delete" style={{ color: packege.is_active ? 'red' : 'green' }} onClick={() => handleDeleteClick(packege)}>
                  {packege.is_active == '1' ?
                    <p style={{ color: packege.is_active ? 'red' : 'green' }}>Deactive</p>
                    :
                    <p>active</p>

                  }
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {lastPage > 1 &&

        <div className="pagination-controls">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            style={{ marginRight: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
          >
            Previous
          </button>
          <span>Page {currentPage} of {lastPage}</span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === lastPage}
            style={{ marginLeft: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
          >
            Next
          </button>
        </div>
      }

      {showModal && (
        <div className="modal show">
          <div className="modal-content">
            <h3 style={{ color: '#000' }}>Are you sure you want to change status of this package?</h3>
            <button className="cancel-button" onClick={cancelDelete} style={{ backgroundColor: "#000" }}>Cancel</button>
            <button className="delete-button" onClick={confirmDelete} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>Change</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Packages;
